import React from "react";
import { IFullPlanDetailPPO } from "../../../interfaces/api";

import PPODoubleInfoBenefit from "./PPODoubleInfoBenefit.component";
import { getDoubleDataPPO } from "../../../functions/planDetails";

const PPODataTableDetailVision = ({ data }: { data: IFullPlanDetailPPO }) => {
  const eyeWearBenefit = getDoubleDataPPO(data, "Eyewear");
  const eyeExamsBenefit = getDoubleDataPPO(
    data,
    "Eye Exams (Medicare and Routine)"
  );
  return (
    <div
      className="grid-x"
      style={{
        backgroundColor: "white",
        border: "1px solid #D3E1F0",

        textAlign: "left",
      }}
    >
      <div
        className="grid-x hide-for-small-only"
        style={{
          backgroundColor: "#F5F9FD",

          width: "100%",
          padding: "32px 20px",
          borderBottom: "1px solid #D3E1F0",
        }}
      >
        <div
          className="cell small-4"
          style={{
            fontSize: "25px",
            fontWeight: 600,
          }}
        ></div>
        <div
          className="cell small-4"
          style={{
            fontSize: "25px",
            fontWeight: 600,
          }}
        >
          In-Network
        </div>
        <div
          className="cell small-4"
          style={{
            fontSize: "25px",
            fontWeight: 600,
            paddingLeft: 20,
          }}
        >
          Out-of-Network
        </div>
      </div>
      <div
        className="grid-x show-for-small-only"
        style={{
          backgroundColor: "#F5F9FD",

          width: "100%",
          padding: "32px 10px",
          borderBottom: "1px solid #D3E1F0",
        }}
      >
        <div className="cell small-4"></div>
        <div
          className="cell small-4"
          style={{
            fontSize: "20px",
            fontWeight: 600,
          }}
        >
          In-Network
        </div>
        <div
          className="cell small-4"
          style={{
            fontSize: "20px",
            fontWeight: 600,
          }}
        >
          Out-of-Network
        </div>
      </div>
      <PPODoubleInfoBenefit benefit={eyeExamsBenefit} title="Eye Exams" />
      <PPODoubleInfoBenefit benefit={eyeWearBenefit} title="Eyewear" />
    </div>
  );
};

export default PPODataTableDetailVision;
